const FONTS_WEIGHT = 'f-400';
const FONTS_FAMILY = 'f-inter';

export { FONTS_WEIGHT as F, FONTS_FAMILY as a };
